export const stringifyArray = (values: string[] | undefined): string => {
  if (values == null || values.length === 0) {
    return '';
  } else if (values.length === 1) {
    return values[0];
  } else {
    return `${values.slice(0, -1).join(', ')} and ${values.slice(-1)}`;
  }
};
